import { makeObservable, computed } from "mobx";
import { BaseSyncModel } from "@/store/sync/BaseSyncModel";
import { SyncModelKind } from "@/store/sync/types";
import { WithAppStore } from "@/store/types";
import { SpaceAccountCalendarModelData } from "@/store/calendar/space-account-calendar/types";
import { SyncUpdateValue } from "@/store/sync/types";

export class SpaceAccountCalendarObservable extends BaseSyncModel<SpaceAccountCalendarModelData> {
  public modelKind = SyncModelKind.SpaceAccountCalendar;

  constructor({
    id,
    data,
    store,
  }: { id: string; data: SyncUpdateValue<SpaceAccountCalendarModelData> } & WithAppStore) {
    super({ id, data, store });

    makeObservable(this, {
      modelKind: false,
      associatedSpaceAccountCalendarConnectionId: computed,
      associatedSpaceAccountCalendarConnection: computed,
      primaryLabel: computed,
      color: computed,
    });
  }

  get associatedSpaceAccountCalendarConnectionId() {
    return this.modelData.associated_space_account_calendar_connection_id;
  }

  get associatedSpaceAccountCalendarConnection() {
    return this.store.spaceAccountCalendarConnections.get(
      this.associatedSpaceAccountCalendarConnectionId
    );
  }

  get primaryLabel() {
    return this.modelData.primary_label;
  }

  get color() {
    return this.modelData.background_color || undefined;
  }
}
